<template>
<div class="mt-4">

<!-- select topic -->	
<Dropdown v-model="item.topic" :options="topics"  class=" z-5 mr-3 border-primary p-inputtext-sm py-0 surface-border"   @change="topicSelected">

<template #value="slotProps">
	<template v-if="slotProps.value">
		<div>{{$store.state.languages.lang_phrases[slotProps.value]}}</div>
	</template>
	<template v-else>
		<div>{{$store.state.languages.lang_phrases.lutfen_bir_konu_secin}}</div>
	</template>
	
</template>
<template #option="slotProps">
<div>{{$store.state.languages.lang_phrases[slotProps.option]}}</div>
</template>
</Dropdown>
<!-- select topic -->	

<!-- select brand -->	
<Dropdown v-if="item.topic=='marka'" v-model="item.brand" :options="brands"  class=" z-5 mr-3 border-primary p-inputtext-sm py-0 surface-border"  optionLabel="name" optionValue="id"  @change="topicSelected">

<template #value="slotProps">
	<template v-if="slotProps.value">
		<div>{{$store.state.languages.lang_phrases[slotProps.value.name]}}</div>
	</template>
	<template v-else>
		<div>{{$store.state.languages.lang_phrases.lutfen_bir_marka_secin}}</div>
	</template>
	
</template>
<template #option="slotProps">
<div>{{$store.state.languages.lang_phrases[slotProps.option.name]}}</div>
</template>
</Dropdown>
<!-- select brand -->	


<!-- select projects -->	
<Dropdown v-if="item.topic=='proje'" v-model="item.projectsupplier" :options="projects"  class=" z-5 mr-3 border-primary p-inputtext-sm py-0 surface-border"  optionLabel="name"   @change="projectSelected" :loading="loading_projects">

<template #value="slotProps">
	<template v-if="slotProps.value">
		<div v-for="translation in slotProps.value.project.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">
		{{translation.translation}}
	</div>
	</template>
	<template v-else>
		<div>{{$store.state.languages.lang_phrases.lutfen_bir_proje_secin}}</div>
	</template>
	
</template>
<template #option="slotProps">
<div v-for="translation in slotProps.option.project.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">
	{{translation.translation}}
</div>
</template>
</Dropdown>
<!-- select projects -->	

<!-- select flows -->	
<Dropdown v-if="item.topic=='akis'" v-model="item.flowsupplier" :options="flows"  class=" z-5 mr-3 border-primary p-inputtext-sm py-0 surface-border"  optionLabel="name"   @change="flowSelected" :loading="loading_flows">

<template #value="slotProps">
	<template v-if="slotProps.value">
		<div v-for="translation in slotProps.value.flow.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">
		{{translation.translation}}
	</div>
	</template>
	<template v-else>
		<div>{{$store.state.languages.lang_phrases.lutfen_bir_asama_secin}}</div>
	</template>
	
</template>
<template #option="slotProps">
<div v-for="translation in slotProps.option.flow.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">
	{{translation.translation}}
</div>
</template>
</Dropdown>
<!-- select flows -->	

<!-- text area -->	
<template v-if="show_text_area">
	

<br/>
<Textarea v-model="item.description" :autoResize="true" :placeholder="$store.state.languages.lang_phrases.lutfen_yasadiginiz_sorunu_bildirin" rows="5" cols="30" class="w-full p-inputtext-sm mt-3 surface-border"/>



<div class="flex align-items-center justify-content-end mt-3">
 <Button type="button"  icon="pi pi-plus" :label="$store.state.languages.lang_phrases.kaydet" class="p-button-primary p-button-outlined p-button-sm "  @click="submitTicket"/> 

</div>
</template>
<!-- text area -->	




</div>
</template>

<script>
export default {

  name: 'TicketAddNew',
  props:["topics","brands"],
  data () {
    return {
    	item:{
    		topic:null,
	    	brand:null,
	    	projectsupplier:null,
	    	flowsupplier:null,
	    	description:null,
    	},
    	projects:[],
    	flows:[],
    	loading_projects:false,
    	loading_flows:false,
    	show_text_area:false,
    }
  },
  methods:{
  	async topicSelected()
  	{
  		console.log(this.item.topic)
  		if(this.item.topic=="genel")
  		{
  			this.show_text_area = true
  		}
  		if(this.item.topic=="marka")
  		{

  		}
  		if(this.item.topic=="proje")
  		{
  		 	this.loading_projects = await true
  		 	this.projects = await this.generalApiGetWithoutLoader("tickets/supplier_user_project_suppliers")
  		 	console.log(this.projects)
  		 	this.loading_projects = await false
  		}

  		if(this.item.topic=="akis")
  		{
  			this.loading_flows = await true
  		 	this.flows = await this.generalApiGetWithoutLoader("tickets/supplier_user_flow_suppliers")
  		 	this.loading_flows = await false
  		}
  	},
  	projectSelected()
  	{
  		console.log(this.item.projectsupplier)
  		this.show_text_area = true
  	},
  	flowSelected()
  	{
  		console.log(this.item.projectsupplier)
  		this.show_text_area = true
  	},
  	submitTicket()
  	{	
  		console.log(this.item)
  		//return false
  		let formdata = new FormData()
  		let data = this.item
  		data.description = data.description.replace(/\n\r?/g, '<br />')
  		formdata.append("data",JSON.stringify(data))
  		this.generalSubmission(formdata,"tickets/submit_supplier_user_ticket",this.aftersubmitTicket)
  	},
  	aftersubmitTicket(response)
  	{
  		console.log(response.data)
  		this.$emit("ticketAdded")
  	}
  }
}
</script>

<style lang="css" scoped>
</style>